(function (root) {
  'use strict';

  function isCalendarDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    var year = Number(value.slice(0, 4));
    var month = Number(value.slice(5, 7));
    var day = Number(value.slice(8, 10));
    var date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
  }

  function validateStay(arrivalISO, departureISO, todayISO) {
    if (!arrivalISO || !departureISO) return { ok: false, code: 'missing' };
    if (!isCalendarDate(arrivalISO) || !isCalendarDate(departureISO) || !isCalendarDate(todayISO)) {
      return { ok: false, code: 'invalid_range' };
    }
    if (arrivalISO < todayISO) return { ok: false, code: 'past_arrival' };
    if (arrivalISO >= departureISO) return { ok: false, code: 'invalid_range' };
    return { ok: true, code: 'ok' };
  }

  function validateGuests(value) {
    return /^[1-3]$/.test(String(value || ''));
  }

  function validateBentralBase(value) {
    try {
      var url = new URL(value);
      return url.protocol === 'https:' && url.hostname === 'www.bentral.com' &&
        url.pathname === '/service/embed/booking.html' &&
        Boolean(url.searchParams.get('id')) && Boolean(url.searchParams.get('key'));
    } catch (_error) {
      return false;
    }
  }

  function buildBentralUrl(baseUrl, options) {
    var url = new URL(baseUrl);
    url.searchParams.set('unit', options.unitId);
    url.searchParams.set('lang', options.locale === 'hr' ? 'hr' : 'sl');
    url.hash = new URLSearchParams({
      persons: String(options.guests),
      arrival: options.arrivalISO,
      departure: options.departureISO
    }).toString();
    return url.toString();
  }

  function buildCalendarUrl(baseUrl, unitId, locale) {
    var url = new URL(baseUrl);
    url.pathname = url.pathname.replace(/booking\.html$/, 'calendar.html');
    url.searchParams.delete('id');
    url.searchParams.set('uid', unitId);
    url.searchParams.set('unit', unitId);
    url.searchParams.set('last', 'true');
    url.searchParams.set('lang', locale === 'hr' ? 'hr' : 'sl');
    url.hash = '';
    return url.toString();
  }

  function ljubljanaToday() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Ljubljana', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date());
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    return values.year + '-' + values.month + '-' + values.day;
  }

  function initStayBooking(rootElement) {
    var arrival = rootElement.querySelector('[data-stay-arrival]');
    var departure = rootElement.querySelector('[data-stay-departure]');
    var guests = rootElement.querySelector('[data-stay-guests]');
    var direct = rootElement.querySelector('[data-stay-direct]');
    var frame = rootElement.querySelector('[data-stay-frame]');
    var result = rootElement.querySelector('[data-stay-result]');
    var status = rootElement.querySelector('[data-stay-status]');
    var error = rootElement.querySelector('[data-stay-error]');
    var view = rootElement.ownerDocument.defaultView;
    var loaded = false;

    frame.addEventListener('load', function () { loaded = true; status.textContent = ''; });
    frame.addEventListener('error', function () { status.textContent = rootElement.dataset.loadError; });
    rootElement.querySelectorAll('[data-stay-unit]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (!validateBentralBase(rootElement.dataset.bentralBase)) {
          error.textContent = rootElement.dataset.loadError;
          return;
        }
        var validity = validateStay(arrival.value, departure.value, ljubljanaToday());
        if (!validity.ok) {
          error.textContent = rootElement.dataset['error' + validity.code.split('_').map(function (part) {
            return part.charAt(0).toUpperCase() + part.slice(1);
          }).join('')] || rootElement.dataset.errorInvalidRange;
          return;
        }
        if (!validateGuests(guests.value)) {
          error.textContent = rootElement.dataset.errorGuests;
          return;
        }
        error.textContent = '';
        loaded = false;
        var url = buildBentralUrl(rootElement.dataset.bentralBase, {
          unitId: button.dataset.unitId,
          locale: rootElement.dataset.locale,
          guests: Number(guests.value),
          arrivalISO: arrival.value,
          departureISO: departure.value
        });
        direct.href = url;
        frame.src = url;
        result.hidden = false;
        status.textContent = rootElement.dataset.loading || '';
        view.setTimeout(function () {
          if (!loaded) status.textContent = rootElement.dataset.loadError;
        }, 12000);
        if (typeof result.scrollIntoView === 'function') result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var calendarFrame = rootElement.querySelector('[data-stay-calendar-frame]');
    var calendarPanel = rootElement.querySelector('[data-stay-calendar-panel]');
    rootElement.querySelectorAll('[data-stay-calendar]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (!validateBentralBase(rootElement.dataset.bentralBase)) {
          error.textContent = rootElement.dataset.loadError;
          return;
        }
        calendarFrame.src = buildCalendarUrl(rootElement.dataset.bentralBase, button.dataset.unitId, rootElement.dataset.locale);
        calendarPanel.hidden = false;
        if (typeof calendarPanel.scrollIntoView === 'function') calendarPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  root.VinicaStayBooking = { validateStay, validateGuests, validateBentralBase, buildBentralUrl, buildCalendarUrl, initStayBooking };
  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-stay-booking]').forEach(initStayBooking);
    });
  }
})(typeof window === 'undefined' ? globalThis : window);
